import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { ItensToInspectViewControllerDelegate, ItensToInspectViewController } from "../../Screen/ItensToInspect/ItensToInspectViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel"; 
import ProtectedRoute from '../../Components/ProtectedRoute'; 
import { ItensToInspectViewModel } from '../../Screen/ItensToInspect/ItensToInspectViewModel';

export class ItensToInspectCoordinator implements IndexCoordinatorDelegate, ItensToInspectViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepitensinspecaodengue")
        return (<ProtectedRoute requiredPermissions={['dengue.itens_insp.*']} path="/:base/dengue/itens-inspecao" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.itens_insp.adicionar',
                    edit: 'dengue.itens_insp.editar',
                    delete: 'dengue.itens_insp.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Tipos de Depósitos"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new ItensToInspectViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.itens_insp.adicionar', 'dengue.itens_insp.editar']} path="/:base/dengue/itens-inspecao/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<ItensToInspectViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepitensinspecaodengue") {
            navigation.history.push(`itens-inspecao/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepitensinspecaodengue") {
            navigation.history.push(`itens-inspecao/cad/${idSelection}`);
            return;
        }
    }

}